import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective {
  @Output() scrollUp = new EventEmitter();
  @Output() scrollDown = new EventEmitter();

  @Input() scrollDirection!: string;
  constructor(private el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  onScroll(event: any): void {
    const el = this.el.nativeElement;
    const scrollTop = el.scrollTop;
    if (this.scrollDirection === 'up') {
      if (scrollTop < 2000) {
        this.scrollUp.emit();
      }
    } else {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1000) {
        this.scrollDown.emit();
      }
    }
  }
}
